// import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { addWidgetsFromContext } from "@insite/client-framework/Components/ContentItemStore";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import "@tsesco/Store/CheckoutReviewAndSubmitCarrierService/CheckoutReviewAndSubmitReducer";
import { css } from "styled-components";
// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
// const pages = require.context("./Pages", true, /\.tsx$/);
// const onHotPageReplace = addPagesFromContext(pages);
// if (module.hot) {
//     module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
// }

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// in production, the widget extensions are included in the chunks created for widgets
if (!IS_PRODUCTION) {
    // load all widget extensions. They could be loaded individually instead
    const widgetExtensions = require.context("./WidgetExtensions", true);
    widgetExtensions.keys().forEach(key => widgetExtensions(key));
}

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [576, 576, 768, 992, 1440],
    },

    typography: {
        fontFamilyImportUrl: "/staticContent/stylesheet.css",
        body: {
            fontFamily: "Roboto-Regular",
            size: "15px",
        },
        p: {
            fontFamily: "Roboto-Regular",
            size: "1rem",
        },
        
        headerPrimary: {
            fontFamily: "Roboto-Bold",
            size: "18px",
        },
        headerSecondary: {
            fontFamily: "Roboto-Bold",
            size: "14px",
        },
        headerTertiary: {
            fontFamily: "Roboto-Medium",
            size: "15px",
        },
        h1: {
            fontFamily: "Roboto-Bold",
            size: "2.25rem",
        },
        h2: {
            fontFamily: "Roboto-Bold",
            size: "1.5rem",
        },
        h3: {
            fontFamily: "Roboto-Bold",
            size: "1rem",
        },
        h4: {
            fontFamily: "Roboto-Bold",
            size: "15px",
        },
        h5: {
            fontFamily: "Roboto-Bold",
            size: "14px",
        },
        h6: {
            fontFamily: "Roboto-Bold",
            size: "13px",
        },
    },

    formField: {
        defaultProps: {
            cssOverrides: {
                formInputWrapper: css`
                    margin-top: 5px !important;
                `,
                inputSelect: css`
                    &:focus {
                        outline-color: #09f;
                        outline-style: solid;
                        outline-width: 1px;
                    }
                `,
            },
            labelProps: {
                color: "#1A1A1A",
                fontFamily: "Roboto-Bold",
                size: "15px",
                transform: "capitalize",
                css: css`
                    .masked-label {
                        color: #464546;
                        font-family: "Roboto-Regular";
                        font-size: 14px;
                        margin-left: 3px;
                        font-weight: 500;
                    }
                `,
            },
        },
    },
    pagination: {
        defaultProps: {
            cssOverrides: {
                pagination: css`
                    background-color: #f3f3f3;
                    padding: 5px;
                `,
                currentButton: css`
                    cursor: default;
                    min-height: 30px;
                `,
                linkList: css`
                    button {
                        /* max-width: 24px; */
                        width: auto;
                    }
                `,
            },
            selectProps: {
                cssOverrides: {
                    formField: css`
                        width: 240px;
                        padding-right: 15px;

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    padding-right: 0px;
                                `,
                                css`
                                    padding-right: 0px;
                                `,
                                css`
                                    padding-right: 0px;
                                `,
                                css`
                                    width: 260px;
                                `,
                                null,
                            ])}
                    `,
                },
                labelProps: {
                    css: css`
                        width: 175px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                null,
                                null,
                                css`
                                    width: 226px;
                                `,
                                null,
                            ])}
                    `,
                },
            },
        },
    },
    dataTable: {
        defaultProps: {
            cssOverrides: {
                head: css`
                    th {
                        background-color: #f3f3f3;
                        border-right: 1px solid #e5e5e5;
                        border-bottom: none;

                        button {
                            height: 90%;
                        }
                    }
                    th:last-child {
                        border-right: none;
                    }
                `,
                body: css`
                    tr:nth-child(even) {
                        background: #ffffff;
                    }
                `,
                cell: css`
                    height: 60px;
                `,
            },
            headerTypographyProps: {
                color: "primary",
            },
        },
    },
    tag: {
        defaultProps: {
            css: css`
                background: ${getColor("primary")};
                align-items: center;
                button {
                    background: ${getColor("primary")};
                    &:hover {
                        background: ${getColor("primary")};
                    }
                }
            `,
        },
    },

});
